import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route, withRouter, Switch } from 'react-router-dom'
import Helmet from 'react-helmet';
import capitalize from 'lodash/capitalize';
import Navbar from 'components/client/navbar';
import Notification from 'components/shared/notification'
import Dashboard from 'containers/client/dashboard'
import Messages from 'containers/client/messages'
import Passport from 'containers/client/passport'
import Account from 'containers/client/account'
import BookingsPayment from 'components/client/bookings/payment'
import NotFound from 'routes/404'

const Client = ({ match, notification: { type, message } }) => {
  const format = location.pathname.replace(/\/client\//, '');
  const header = location.pathname === '/client' ? 'Dashboard' : format;
  return (
    <Fragment>
      {type && <Notification type={type} message={message} />}
      <Helmet>
        <title>{capitalize(header.replace(/\//g, ' > '))} | Client</title>
        <meta name='description' content="FlySpaces is Southeast Asia's Leading Digital Platform for Office Space and Flexible Workspace Solutions, Helping SMEs, Multinationals, and Entrepreneurs Save Time and Money." />
      </Helmet>
      <Navbar />
      <div className="client min-h-vh-msg">
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            component={Dashboard} />
          <Route
            path={`${match.path}/messages/:filter?`}
            component={Messages} />
          <Route
            path={`${match.path}/passport`}
            component={Passport}
          />
          <Route
            path={`${match.path}/account`}
            component={Account} />
          <Route
            path={`${match.path}/transaction/pay/:id`}
            component={BookingsPayment} />
          <Route component={NotFound} />
        </Switch>
      </div>
    </Fragment>
  )
}

Client.propTypes = {
  match: PropTypes.object.isRequired,
  notification: PropTypes.object,
}

const mapStateToProps = ({ notification }) => ({
  notification,
})

export default connect(mapStateToProps)(withRouter(Client))
